export default __webpack_public_path__ + "static/media/pickshare01.2f9d581a.png";